<template>
  <div>
    <template v-if="uid">
      <navigation></navigation>
      <v-content>
        <router-view></router-view>
        <basic-data
          v-if="recabarDatos"
          :usuario1="usuarioComb"
          :pantalla="pantalla"
          :dataModel="data"
        ></basic-data>
      </v-content>
      <v-footer color="blue lighten-1" app>
        <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
      </v-footer>
    </template>
    <template v-else>
      <Login />
    </template>
  </div>
</template>

<script>
import Navigation from "./modules/navigation";
import Login from "./login";
import BasicData from "./propietarios/basic-data";

import { mapGetters, mapActions } from "vuex";
export default {
  name: "User",
  components: {
    Navigation,
    Login,
    BasicData
  },
  data() {
    return {
      vista: "expedientes",
      pantalla: [
        ["nombre", "apellidos"],
        ["calle", "cp", "localidad", "provincia"],
        ["nif", "tlf", "fechaNacimiento"]
      ],
      data: {
        nombre: null,
        apellido1: null,
        apellido2: null,
        nif: null,
        tlf: [],
        fechaNacimiento: null,
        direccion: {
          calle: null,
          cp: null,
          localidad: null,
          provincia: null
        }
      }
    };
  },
  created() {
    this.setUsuario();
    this.setPropietario();
    this.setProvincias();
    this.setComunidades();
    this.setExpedientesStatus();
  },
  methods: {
    ...mapActions([
      "setUsuario",
      "setPropietario",
      "setExpedientesStatus",
      "setProvincias",
      "setComunidades"
    ])
    /* setUsuario() {
      this.$store.dispatch("setUsuario");
    },
    setExpedientesStatus() {
      this.$store.dispatch("setExpedientesStatus");
    },
    setProvincias() {
      this.$store.dispatch("setProvincias");
    },
    setComunidades() {
      this.$store.dispatch("setComunidades");
    } */
  },
  computed: {
    ...mapGetters(["propietario", "level", "getUserUid"]),
    usuarioComb() {
      return JSON.parse(
        JSON.stringify(Object.assign({}, this.usuario, this.data))
      );
    },
    recabarDatos() {
      if (this.level < 5) {
        if (this.usuario === "sin datos") {
          return true;
        } else {
          for (let index = 0; index < this.pantalla.length; index++) {
            for (let i = 0; i < this.pantalla[index].length; i++) {
              const element = this.pantalla[index][i];
              if (!this.data[element]) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    usuario() {
      // return this.$store.getters.getUsuarioAdd;
      return this.propietario;
    },
    /* level() {
      // return this.$store.state.level;
      return this.level;
      // return this.$store.state.level || this.uid ? 1 : false
    }, */
    /* user() {
            return this.$store.getters.getUser
        }, */
    uid() {
      // return this.$store.getters.getUserUid;
      return this.getUserUid;
    }
  }
};
</script>
